import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebasePlanConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,

  // Put your PLANNER Firebase project ID here
  projectId: "birthdays-mine",

  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: "G-DQMR01P82H"
};

// Give this Firebase app its own name
const appName = "firebasePlan";

const planApp = getApps().some(
  (app) => app.name === appName
)
  ? getApp(appName)
  : initializeApp(firebasePlanConfig, appName);

export const dbPlan = getFirestore(planApp);